import { AttributeValue } from "./AttributeValue";

/**
 * 画面表示用属性クラス
 */
export class AttributeView {
  /**
   * 画面サイズ（幅）
   */
  width: number;

  /**
   * 画面サイズ(高さ・詳細非表示時)
   */
  height: number;

  /**
   * 画面サイズ（高さ・詳細表示時）
   */
  maxheight: number;

  /**
   * タイトル
   */
  title: string;

  /**
   * タイトル最大文字数
   */
  titleMaxLength?: number;

  /**
   * CSV出力可否
   */
  csvOutputUnPossibility?: boolean;

  /**
   * JSON出力可否
   */
  jsonOutputUnPossibility?: boolean;

  /**
   * 画面項目リスト
   */
  attributeValues: Array<AttributeValue>;

  constructor(
    attributeValues: Array<AttributeValue>,
    title?: string,
    width?: number,
    height?: number,
    maxheight?: number,
    titleMaxLength?: number,
    csvOutputUnPossibility?: boolean,
    jsonOutputUnPossibility?: boolean
  ) {
    this.attributeValues = attributeValues;
    this.title = title ? title : "";
    this.width = width ? width : 300;
    this.height = height ? height : 300;
    this.maxheight = maxheight ? height : 400;
    this.titleMaxLength = titleMaxLength;
    this.csvOutputUnPossibility = csvOutputUnPossibility;
    this.jsonOutputUnPossibility = jsonOutputUnPossibility;
  }
}
